module.exports = __webpack_public_path__ + "static/media/icon-warning-big.d4f72325.png";